import type { FCWithChildren } from '@pbk-web/types';
import { dataAttributeProps } from '@pbk-web/utils';
import { createElement } from 'react';

export enum HeadingSize {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
  CUSTOM = 'span',
}

type HeadingProps = {
  size?: HeadingSize;
  actualSize?: HeadingSize; // used if you want to use a different size than the enum for a11y structure purposes
  className?: string;
  textColor?: string;
  onClick?: () => void;
  id?: string;
};

const fontSizes = {
  [HeadingSize.H1]: 'text-pbk-48',
  [HeadingSize.H2]: 'text-pbk-40',
  [HeadingSize.H3]: 'text-pbk-32',
  [HeadingSize.H4]: 'text-pbk-25',
  [HeadingSize.H5]: 'text-pbk-20',
  [HeadingSize.H6]: 'text-pbk-16',
  [HeadingSize.CUSTOM]: '',
};

export const Heading: FCWithChildren<HeadingProps> = (props) => {
  const { children, size = HeadingSize.H2, className, textColor, onClick, id, actualSize } = props;
  const fontSize = fontSizes[actualSize || size];
  // Default color if none provided
  const color = textColor || 'text-primary-100';
  return createElement(
    size,
    {
      id,
      onClick,
      className: `${fontSize} ${color} ${onClick !== undefined ? 'cursor-pointer' : ''} ${className || ''}`,
      'data-testid': `heading-${size}`,
      ...dataAttributeProps(props),
    },
    children,
  );
};
